import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Unstable_Grid2';
import OutlinedInput from '@mui/material/OutlinedInput';
import { styled } from '@mui/material/styles';

const FormGrid = styled(Grid)(() => ({
	display: 'flex',
	flexDirection: 'column',
}));

export default function PersonalDetailsForm({ formData, setFormData }) {
	const handleChange = (event) => {
		const { name, value } = event.target;
		setFormData((prevData) => ({ ...prevData, [name]: value }));
	};

	return (
		<Grid container spacing={3}>
			<FormGrid size={{ xs: 12, md: 6 }}>
				<FormLabel htmlFor="first-name" required>
					First Name
				</FormLabel>
				<OutlinedInput
					id="first-name"
					name="firstName"
					type="text"
					required
					size="small"
					value={formData.firstName || ''}
					onChange={handleChange}
				/>
			</FormGrid>
			<FormGrid size={{ xs: 12, md: 6 }}>
				<FormLabel htmlFor="last-name" required>
					Last Name
				</FormLabel>
				<OutlinedInput
					id="last-name"
					name="lastName"
					type="text"
					required
					size="small"
					value={formData.lastName || ''}
					onChange={handleChange}
				/>
			</FormGrid>
			<FormGrid size={{ xs: 12, md: 6 }}>
				<FormLabel htmlFor="gender" required>
					Gender
				</FormLabel>
				<OutlinedInput
					id="gender"
					name="gender"
					type="text"
					required
					size="small"
					value={formData.gender || ''}
					onChange={handleChange}
				/>
			</FormGrid>
			<FormGrid size={{ xs: 12, md: 6 }}>
				<FormLabel htmlFor="dateOfBirth" required>
					Date of Birth
				</FormLabel>
				<OutlinedInput
					id="dateOfBirth"
					name="dateOfBirth"
					type="date"
					required
					size="small"
					value={formData.dateOfBirth || ''}
					onChange={handleChange}
				/>
			</FormGrid>
			<FormGrid size={{ xs: 12, md: 6 }}>
				<FormLabel htmlFor="emailAddress" required>
					Email Address
				</FormLabel>
				<OutlinedInput
					id="emailAddress"
					name="emailAddress"
					type="text"
					required
					size="small"
					value={formData.emailAddress || ''}
					onChange={handleChange}
				/>
			</FormGrid>
			<FormGrid size={{ xs: 12 }}>
				<FormLabel htmlFor="addressLine1" required>
					Address Line 1
				</FormLabel>
				<OutlinedInput
					id="addressLine1"
					name="addressLine1"
					type="text"
					placeholder="Street name and number"
					required
					size="small"
					value={formData.addressLine1 || ''}
					onChange={handleChange}
				/>
			</FormGrid>
			<FormGrid size={{ xs: 12 }}>
				<FormLabel htmlFor="addressLine2">Address Line 2</FormLabel>
				<OutlinedInput
					id="addressLine2"
					name="addressLine2"
					type="text"
					placeholder="Apartment, suite, unit, etc. (optional)"
					size="small"
					value={formData.addressLine2 || ''}
					onChange={handleChange}
				/>
			</FormGrid>
			<FormGrid size={{ xs: 6 }}>
				<FormLabel htmlFor="city" required>
					City
				</FormLabel>
				<OutlinedInput
					id="city"
					name="city"
					type="text"
					required
					size="small"
					value={formData.city || ''}
					onChange={handleChange}
				/>
			</FormGrid>
			<FormGrid size={{ xs: 6 }}>
				<FormLabel htmlFor="postcode" required>
					Postcode
				</FormLabel>
				<OutlinedInput
					id="postcode"
					name="postcode"
					type="text"
					required
					size="small"
					value={formData.postcode || ''}
					onChange={handleChange}
				/>
			</FormGrid>
		</Grid>
	);
}
